<template>
  <div>
    <v-navigation-drawer
      app
      permanent
      clipped
    >
      <v-list>
        <v-list-item class="px-2">
          <v-menu
            left
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                x-large
                v-on="on"
              >
                <v-avatar
                  color="#00aab0"
                  size="28"
                >
                  <span class="white--text">{{ user.avatar }}</span>
                </v-avatar>
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-if="user.isStudent" @click="downloadPrivateKey">
                <v-list-item-title>
                  <v-icon left>mdi-file-key</v-icon>
                  Chave privada
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canChangePassword()" :to="{ name: 'UserPassword' }">
                <v-list-item-title>
                  <v-icon left>mdi-form-textbox-password</v-icon>
                  Alterar senha
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="logoff">
                <v-list-item-title>
                  <v-icon left>mdi-exit-to-app</v-icon>
                  Sair
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ user.name }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense subheader v-if="user.isAdmin">
        <v-subheader inset>
          <v-icon left>mdi-shield-account</v-icon>Administrador
        </v-subheader>

        <v-list-item :to="{ name: 'AdminCourses' }">
          <v-list-item-avatar>
            <v-icon>mdi-book-open-variant</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Cursos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'AdminUsers' }">
          <v-list-item-avatar>
            <v-icon>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'AdminEnrolmentMachines' }">
          <v-list-item-avatar>
            <v-icon>mdi-desktop-classic</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Máquinas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense subheader v-if="user.isTeacher">
        <v-subheader inset>
          <v-icon left>mdi-penguin</v-icon>Professor
        </v-subheader>

        <v-list-item :to="{ name: 'TeacherUsers' }">
          <v-list-item-avatar>
            <v-icon>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense subheader v-if="user.isStudent">
        <v-subheader inset>
          <v-icon left>mdi-school</v-icon>Estudante
        </v-subheader>

        <v-list-item :to="{ name: 'StudentMachines' }">
          <v-list-item-avatar>
            <v-icon>mdi-desktop-classic</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Máquinas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user.isStudent" @click="downloadPrivateKey">
          <v-list-item-avatar>
            <v-icon>mdi-file-key</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Chave privada</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="accent-4"
      elevation="1"
      dense
      dark
      clipped-left
    >
      <v-toolbar-title>
        <img class="mt-2" src="@/assets/images/4linux.png" alt="" width="30" height="30">
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu
        left
        bottom
        v-if="user.isAdmin"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>mdi-google-cloud</v-icon>
            GCP
          </v-btn>
        </template>

        <v-list>
          <v-list-item  @click="updateGcpZones">
            <v-list-item-title>
              <v-icon left>mdi-map</v-icon>
              Atualizar zonas
            </v-list-item-title>
          </v-list-item>
          <v-list-item  @click="updateGcpImages">
            <v-list-item-title>
              <v-icon left>mdi-cloud-sync</v-icon>
              Atualizar imagens
            </v-list-item-title>
          </v-list-item>
          <v-list-item  @click="updateGcpDiskTypes">
            <v-list-item-title>
              <v-icon left>mdi-harddisk</v-icon>
              Atualizar tipos de disco
            </v-list-item-title>
          </v-list-item>
          <v-list-item  @click="updateGcpMachineTypes">
            <v-list-item-title>
              <v-icon left>mdi-desktop-classic</v-icon>
              Atualizar tipos de máquinas
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-spacer></v-spacer>

      <v-menu
        left
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            x-large
            v-on="on"
          >
            <v-avatar
              color="#00aab0"
              size="28"
            >
              <span class="white--text">{{ user.avatar }}</span>
            </v-avatar>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-if="user.isStudent" @click="downloadPrivateKey">
            <v-list-item-title>
              <v-icon left>mdi-file-key</v-icon>
              Chave privada
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="canChangePassword()" :to="{ name: 'UserPassword' }">
            <v-list-item-title>
              <v-icon left>mdi-form-textbox-password</v-icon>
              Alterar senha
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="logoff">
            <v-list-item-title>
              <v-icon left>mdi-exit-to-app</v-icon>
              Sair
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-main>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AuthService from '@/services/auth/auth.service';
import StudentService from '@/services/student/student.service';
import GcpService from '@/services/gcp/gcp.service';

const authService = new AuthService();
const decoded = authService.getDecoded();

const studentService = new StudentService();
const gcpService = new GcpService();

export default {
  name: 'Layout',
  data: () => ({
    user: {
      name: decoded.name,
      email: decoded.email,
      roles: decoded.roles,
      auth: decoded.auth,
      avatar: decoded.name.charAt(0).toUpperCase(),
      isAdmin: authService.isAdmin(),
      isTeacher: authService.isTeacher(),
      isStudent: authService.isStudent(),
    },
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    logoff() {
      authService.logoff();
      this.$router.push('/login');
    },
    canChangePassword() {
      return this.user.auth === 'password';
    },
    downloadPrivateKey() {
      studentService.privateKey()
        .then((response) => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          });
          const url = window.URL.createObjectURL(blob)
          window.open(url);
        });
    },
    updateGcpZones() {
      this.loading = true;

      gcpService.updateZones()
        .then((response) => this.showSnack(response.data.message))
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    updateGcpImages() {
      this.loading = true;

      gcpService.updateImages()
        .then((response) => this.showSnack(response.data.message))
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    updateGcpDiskTypes() {
      this.loading = true;

      gcpService.updateDiskTypes()
        .then((response) => this.showSnack(response.data.message))
        .catch(console.error)
        .finally(() => this.loading = false);
    },
    updateGcpMachineTypes() {
      this.loading = true;

      gcpService.updateMachineTypes()
        .then((response) => this.showSnack(response.data.message))
        .catch(console.error)
        .finally(() => this.loading = false);
    },
  },
};
</script>

<style scoped>

</style>
